// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"afbd0158","893":"2157a78c"}[chunkId] + ".chunk.css";
};